export default {
  slices: [
    {
      field: 'market',
      display: 'Market',
      map: {
        general: {
          display: 'General Market',
          sortOrder: 1
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        video: {
          display: 'Video',
          mediaType: 'mp4',
          sortOrder: 1
        },
        social_video: {
          display: 'Social Video',
          mediaType: 'mp4',
          sortOrder: 2
        },
        radio: {
          display: 'Radio',
          mediaType: 'mp4',
          sortOrder: 3
        }
      }
    },
    
  ]
};


// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/config/metadata.js